import React from 'react';
import { Avatar } from 'antd';
import { useSelector } from 'react-redux';
import MyHeader from '../Header/Header.module.css';

const MembersGroup = ({ size = 32 }) => {
  const document = useSelector((state) => state.editor.documentInformation);
  const user = useSelector((state) => state.editor.userInformation);
  const collaborators = (document?.members || []).filter(m => m.id !== user?.userId);
  const count = collaborators.length;
  const firstMember = collaborators[0];

  const label = count ? `${count + (document?.members?.length && !collaborators.length ? 0 : 0)}` : '0';

  return (
    <div className={MyHeader.membersGroupWrapper}>
      <div style={{ position: 'relative' }}>
        {firstMember?.image ? (
          <Avatar size={size} src={firstMember.image} />
        ) : (
          <Avatar size={size}>{firstMember?.name ? firstMember.name.charAt(0).toUpperCase() : 'M'}</Avatar>
        )}
        {count > 1 && (
          <div className={MyHeader.memberBadge}>{`+${count}`}</div>
        )}
      </div>
    </div>
  );
};

export default MembersGroup;